<template>
    <div class="container py-3">
      <div v-if="loading" class="text-center my-5">
        <div class="spinner-border text-primary" role="status"></div>
      </div>
  
      <form v-else @submit.prevent="submitForm">
        <!-- Infos générales -->
        <div class="row mb-3">
          <div class="col-md-6">
            <label>Prénom</label>
            <input type="text" class="form-control" v-model="form.prenom" required>
          </div>
          <div class="col-md-6">
            <label>Nom</label>
            <input type="text" class="form-control" v-model="form.nom" required>
          </div>
        </div>
  
        <div class="row mb-3">
          <div class="col-md-6">
            <label>Email</label>
            <input type="email" class="form-control" v-model="form.email" required>
          </div>
          <div class="col-md-6">
            <label>Téléphone</label>
            <input type="tel" class="form-control" v-model="form.telephone" required>
          </div>
        </div>
  
        <div class="mb-3">
          <label>Adresse</label>
          <input type="text" class="form-control" v-model="form.adresse">
        </div>
  
        <div class="mb-3">
          <label>Ville</label>
          <select v-model="form.ville" class="form-select" required>
              <option v-for="ville in villes" :value="ville.libelle" :key="ville.id">
                {{ ville.libelle }}
              </option>
            </select>
        </div>
  
        <!-- Liens -->
        <div class="row mb-3">
          <div class="col-md-6">
            <label>LinkedIn</label>
            <input type="url" class="form-control" v-model="form.linkedin">
          </div>
          <div class="col-md-6">
            <label>Portfolio</label>
            <input type="url" class="form-control" v-model="form.portfolio">
          </div>
        </div>
  
        <!-- Métiers -->
        <div class="mb-3">
          <label class="form-label">Métiers (jusqu’à 5)</label>
          <div class="row">
            <div class="col-md-6 mb-2" v-for="key in metierFields" :key="key">
              <select class="form-select" v-model="form[key]">
                <option value="">-- Sélectionner --</option>
                <option v-for="metier in filteredMetiers(key)" :key="metier.id" :value="metier.libelle">
                  {{ metier.libelle }}
                </option>
              </select>
            </div>
          </div>
        </div>
  
        <!-- Autres infos -->
        <div class="row mb-3">
          <div class="col-md-4">
            <label>Expérience (années)</label>
            <input type="number" class="form-control" v-model="form.experience" min="0">
          </div>
          <div class="col-md-4">
            <label>Étoiles (0–5)</label>
            <input type="number" class="form-control" v-model="form.etoiles" min="0" max="5">
          </div>
          <div class="col-md-4">
            <label>Newsletter</label>
            <select class="form-select" v-model="form.newsletter">
              <option :value="true">Oui</option>
              <option :value="false">Non</option>
            </select>
          </div>
        </div>
  
        <div class="mb-3">
          <label>Bio</label>
          <textarea class="form-control" rows="3" v-model="form.bio"></textarea>
        </div>
  
        <!-- <div class="mb-3">
          <label>Photo URL</label>
          <input type="text" class="form-control" v-model="form.photo_url">
        </div>
  
        <div class="mb-3">
          <label>Email vérifié le</label>
          <input type="datetime-local" class="form-control" v-model="form.email_verified_at">
        </div> -->
  
        <!-- Actions -->
        <div class="d-flex justify-content-end mt-4">
          <button class="btn btn-primary" type="submit">
            <i class="fas fa-save me-2"></i> Enregistrer
          </button>
        </div>
      </form>
    </div>
  </template>
  
  <script >
  import { defineComponent } from 'vue';
  import $ from 'jquery'
  
  export default defineComponent({
    name: 'UserForm',
    inject: ['dialogRef'],
    data() {
      return {
        table: 'users',
        loading: true,
        villes: [],
        metiers: [],
        metierFields: [
          'metier',
          'metier_deux',
          'metier_trois',
          'metier_quatre',
          'metier_cinq'
        ],
        form: {
          password: 'etuiweyuwieywyebgwbbgugskjhhf',
          name: '',
          email: '',
          prenom: '',
          nom: '',
          adresse: '',
          telephone: '',
          ville: '',
          linkedin: '',
          portfolio: '',
          metier: '',
          metier_deux: '',
          metier_trois: '',
          metier_quatre: '',
          metier_cinq: '',
          experience: 0,
          newsletter: false,
          bio: '',
          etoiles: 0,
        //   email_verified_at: '',
          photo_url: ''
        }
      };
    },
    methods: {
      async loadMetiers() {
        try {
          const response = await this.axios.get('/api/metiers');
          this.metiers = response.data.data;
        } catch (error) {
          console.error('Erreur chargement métiers :', error);
        }
      },
      async loadVilles() {
        try {
          const response = await this.axios.get('/api/villes');
          this.villes = response.data.data;
        } catch (error) {
          console.error('Erreur chargement villes :', error);
        }
      },
      filteredMetiers(currentKey) {
        const selected = this.metierFields
          .filter(k => k !== currentKey)
          .map(k => this.form[k]);
  
        return this.metiers.filter(m => !selected.includes(m.nom));
      },
      async submitForm() {
        const isUpdate = !!this.dialogRef.data?.id;
        const url = isUpdate
          ? `/api/utilisateurs/${this.dialogRef.data.id}/update`
          : '/api/utilisateurs';
  
        try {
            const response = await this.axios.post(url, this.form);
          if (response.data.success === true) {
                    if(!isUpdate) this.resetForm()
                    // actualiser le tableau,
                    $('#refresh' + this.table).click()
                    //fermer le modal
                    this.dialogRef.close()
                    //afficher le toast en cas de succes
                    this.$toast.add({
                        severity: 'success',
                        detail: response.data.message || 'Opération réussie',
                        life: 3000
                    });
                } else {
                    //afficher le toast avec les erreurs du serveurs
                    const errors = response.data.errors || ['Une erreur est survenue'];
                    if (Array.isArray(errors)) {
                        errors.forEach(element => {
                            this.$toast.add({
                                severity: 'warn',
                                summary: 'Oups !',
                                detail: element,
                                life: 7000
                            });
                        });
                    }
                }
        } catch (err) {
          console.error('Erreur enregistrement :', err);
        }
      },
      hydrateForm() {
        if (this.dialogRef.data) {
          this.form = { ...this.form, ...this.dialogRef.data };
        }
      },
      resetForm(){
        this.form = {
          password: 'etuiweyuwieywyebgwbbgugskjhhf',
          name: '',
          email: '',
          prenom: '',
          nom: '',
          adresse: '',
          telephone: '',
          ville: '',
          linkedin: '',
          portfolio: '',
          metier: '',
          metier_deux: '',
          metier_trois: '',
          metier_quatre: '',
          metier_cinq: '',
          experience: 0,
          newsletter: false,
          bio: '',
          etoiles: 0,
        //   email_verified_at: '',
          photo_url: ''
        }
      }
    },
    async mounted() {
      await this.loadMetiers();
      await this.loadVilles()
      this.hydrateForm();
      this.loading = false;
    }
  });
  </script>
  